// extracted by mini-css-extract-plugin
module.exports = {"base":"contactOptions_base__e390O","wrapper":"contactOptions_wrapper__G1fB6","alignment":"contactOptions_alignment__iy9_2","link":"contactOptions_link__hg3B4"};